import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-main-indicators',
  templateUrl: './main-indicators.component.html',
  styleUrl: './main-indicators.component.scss'
})
export class MainIndicatorsComponent implements OnInit {

  periods: { label: string; value: string }[] = [];
  selectedPeriod = '2019-2021';

  constructor() { }
  alldata = [
    { persentage: "4.3%", year: "2015-2016" },
    { persentage: "4.2%", year: "2016-2017" },
    { persentage: "4%", year: "2017-2018" },
    { persentage: "5.6%", year: "2018-2019" },
    { persentage: "3.6%", year: "2019-2020" },
    { persentage: "3.3%", year: "2020-2021" }
  ];

  ngOnInit(): void {
    this.generatePeriods();
  }

  generatePeriods() {
    this.periods.push({
      label: 'يناير 2019 - ديسمبر 2021',
      value: '2019-2021'
    });

    const years = [2019, 2020, 2021];
    const quarters = [
      'الربع السنوي الأول',
      'الربع السنوي الثاني',
      'الربع السنوي الثالث',
      'الربع السنوي الرابع'
    ];

    years.forEach(year => {
      quarters.forEach((quarter, index) => {
        this.periods.push({
          label: `${year} - ${quarter}`,
          value: `${year}-Q${index + 1}`
        });
      });
    });
  }
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {
    chart: {
      type: 'pie'
    },
    title: {
      text: 'توزيع القطاعات الاقتصادية 2019-2020'
    },
    series: [{
      type: 'pie',
      data: [
        { name: 'الزراعة', y: 10 },
        { name: 'الغاز و البترول', y: 15 },
        { name: 'الصناعة', y: 20 },
        { name: 'البنية التحتية', y: 5 },
        { name: 'البناء', y: 8 },
        { name: 'النقل و التخزين', y: 7 },
        { name: 'تكنولوجيا الاتصالات', y: 6 },
        { name: 'السويس', y: 4 },
        { name: 'تجارة الجملة و التجزئة', y: 9 },
        { name: 'المالية', y: 5 },
        { name: 'العقارات', y: 6 },
        { name: 'الخدمات', y: 3 },
        { name: 'أخرى', y: 2 }
      ]
    }]
  };
  LineHighchart: typeof Highcharts = Highcharts;
  LinechartOptions: Highcharts.Options = {
    title: {
      text: 'معدل التضخم'
    },
    xAxis: {
      categories: ['1-2021', '2-2021', '3-2021', '4-2021', '5-2021', '6-2021', '7-2021', '8-2021'],
      title: { text: 'المدة الزمنية' }
    },
    yAxis: {
      title: { text: 'معدل التضخم' }
    },
    series: [{
      type: 'line',
      name: 'معدل التضخم',
      data: [4.8, 5.0, 4.6, 4.4, 4.5, 5.2, 5.8, 6.4],
      color: '#007bff'
    }, {
      type: 'scatter',
      name: 'ملاحظة خاصة',
      data: [{ x: 4, y: 4.2 }],
      color: '#ff0000'
    }]
  };
}
